import React from 'react';
import styled, { keyframes } from 'styled-components';

// Task Manager — fake processes with Dead Simple Computing easter eggs
const PROCESSES = [
    { name: 'svchost.exe', user: 'SYSTEM', cpu: '0', mem: '4,128 K' },
    { name: 'explorer.exe', user: 'Dave', cpu: '2', mem: '28,544 K' },
    { name: 'csrss.exe', user: 'SYSTEM', cpu: '0', mem: '2,088 K' },
    { name: 'winlogon.exe', user: 'SYSTEM', cpu: '0', mem: '3,756 K' },
    { name: 'lsass.exe', user: 'SYSTEM', cpu: '0', mem: '1,280 K' },
    { name: 'spoolsv.exe', user: 'SYSTEM', cpu: '0', mem: '5,640 K' },
    { name: 'iexplore.exe', user: 'Dave', cpu: '12', mem: '45,312 K' },
    { name: 'iexplore.exe', user: 'Dave', cpu: '8', mem: '38,924 K' },
    { name: 'winamp.exe', user: 'Dave', cpu: '3', mem: '12,800 K' },
    { name: 'msnmsgr.exe', user: 'Dave', cpu: '1', mem: '8,192 K' },
    { name: 'outlook.exe', user: 'Dave', cpu: '5', mem: '22,016 K' },
    // Suspicious processes...
    { name: 'totally_legit.exe', user: 'Dave', cpu: '47', mem: '128,000 K' },
    { name: 'not_a_virus.exe', user: 'Dave', cpu: '23', mem: '64,512 K' },
    { name: 'free_smileys.exe', user: 'Dave', cpu: '15', mem: '32,768 K' },
    { name: 'bonzibuddy.exe', user: 'Dave', cpu: '18', mem: '48,000 K' },
    { name: 'toolbar_helper.exe', user: 'Dave', cpu: '8', mem: '16,384 K' },
    { name: 'crypto_miner.exe', user: 'Dave', cpu: '99', mem: '256,000 K' },
    { name: 'toolbar_helper2.exe', user: 'Dave', cpu: '6', mem: '12,288 K' },
    { name: 'comet_cursor.exe', user: 'Dave', cpu: '4', mem: '8,192 K' },
    { name: 'gator.exe', user: 'Dave', cpu: '7', mem: '24,576 K' },
    { name: 'coolwebsearch.exe', user: 'Dave', cpu: '11', mem: '20,480 K' },
    { name: 'kazaa_buddy.exe', user: 'Dave', cpu: '9', mem: '32,000 K' },
    { name: 'winfixer_pro.exe', user: 'Dave', cpu: '14', mem: '40,960 K' },
    { name: 'svchost_helper.exe', user: 'SYSTEM', cpu: '22', mem: '80,000 K' },
];

function TaskManager() {
    const totalCPU = PROCESSES.reduce((acc, p) => acc + parseInt(p.cpu), 0);

    return (
        <Container>
            <TabBar>
                <Tab>Applications</Tab>
                <Tab className="active">Processes</Tab>
                <Tab>Performance</Tab>
                <Tab>Networking</Tab>
            </TabBar>
            <ProcessList>
                <HeaderRow>
                    <Col flex={3}>Image Name</Col>
                    <Col flex={2}>User Name</Col>
                    <Col flex={1}>CPU</Col>
                    <Col flex={2}>Mem Usage</Col>
                </HeaderRow>
                {PROCESSES.map((proc, i) => (
                    <ProcessRow key={i} suspicious={parseInt(proc.cpu) > 10}>
                        <Col flex={3}>{proc.name}</Col>
                        <Col flex={2}>{proc.user}</Col>
                        <Col flex={1}>{proc.cpu}%</Col>
                        <Col flex={2}>{proc.mem}</Col>
                    </ProcessRow>
                ))}
            </ProcessList>
            <StatusBar>
                <span>Processes: {PROCESSES.length}</span>
                <span>CPU Usage: {Math.min(totalCPU, 247)}%</span>
                <span>Commit Charge: 847M / 512M</span>
            </StatusBar>
            <Warning>
                ⚠️ 18 of {PROCESSES.length} processes appear to be malware.
                <br />
                Call Dead Simple Computing on 0118 359 2220 for help.
            </Warning>
        </Container>
    );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ECE9D8;
  font-family: Tahoma, sans-serif;
  font-size: 11px;
`;

const TabBar = styled.div`
  display: flex;
  padding: 4px 4px 0;
  gap: 0;
`;

const Tab = styled.div`
  padding: 4px 12px;
  background: #ECE9D8;
  border: 1px solid #ACA899;
  border-bottom: none;
  border-radius: 3px 3px 0 0;
  cursor: pointer;
  margin-right: -1px;
  &.active {
    background: #fff;
    font-weight: bold;
    position: relative;
    z-index: 1;
  }
`;

const ProcessList = styled.div`
  flex: 1;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ACA899;
  margin: 0 4px;
`;

const HeaderRow = styled.div`
  display: flex;
  background: #ECE9D8;
  border-bottom: 1px solid #ACA899;
  font-weight: bold;
  position: sticky;
  top: 0;
`;

const ProcessRow = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  background: ${({ suspicious }) => suspicious ? '#fff0f0' : 'transparent'};
  color: ${({ suspicious }) => suspicious ? '#cc0000' : '#000'};
  &:hover { background: #316AC5; color: #fff; }
`;

const Col = styled.div`
  flex: ${({ flex }) => flex};
  padding: 2px 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StatusBar = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  border-top: 1px solid #ACA899;
  background: #ECE9D8;
  color: #333;
`;

const Warning = styled.div`
  padding: 6px 8px;
  background: #FFF3CD;
  border-top: 1px solid #FFD700;
  color: #856404;
  text-align: center;
  font-weight: bold;
`;

export default TaskManager;
